export default __webpack_public_path__ + "media/src/assets/images/manualColor-10d94831ad7a559059ad91cc12a58177.png";